import React,{ useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import EMDBcart from  '../../utils/emdb.cart.js'
import EMDButils from  '../../utils/emdb.utils.js'
import EmdbButtom from "../../components/EmdbButtom";
import EmdbToast from "../../components/EmdbToast";

import VTCalendar from "./components/VTCalendar/VTCalendar.js";
import VTSelectLanguage from "./components/VTSelectLanguage/VTSelectLanguage.js";
import VTPrice from "./components/VTPrices/VTPrices.js";
import VTSummary from "./components/VTSummary/VTSummary.js";
import VTConfirmDialog from "./components/VTConfirmDialog/VTConfirmDialog";

//ICON
import LoadingIcon from "../../assets/img/loading-icon-white.svg";

//CSS
//import "primereact/resources/themes/lara-light-cyan/theme.css";
import styles from './VTForm.module.less';


function VTForm({config}) {

  const debug =  config.hasOwnProperty('debug') ? config.debug : false
  const msgs = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [excursionID, setExcursionID] = useState(() => config.hasOwnProperty('product') ? config.product : null);
  const [excursionInfo, setExcursionInfo] = useState(null);
  const [excursionDate, setExcursionDate] = useState(null);
  const [excursionLanguage, setExcursionLanguage] = useState(null);
  const [excursionDeparture, setExcursionDeparture] = useState(null);
  const [excursionsPrices, setExcursionsPrices] = useState(null);
  const [specialExcursion, setSpecialExcursion] = useState(null);
  const [hotelID, setHotelID] = useState(null);
  const [availability, setAvailability] = useState(null);
  const [showAvailability, setShowAvailability] = useState(false);
  const [paxMax, setPaxMax] = useState(0);
  const [bookedPax, setBookedPax] = useState(null);
  const {t, i18n} = useTranslation("vtform");

  const emdbCart  = new EMDBcart('vtformcart');
  const emdbUtils = new EMDButils();

  const collaboratorID = config.hasOwnProperty('collaborator') ? config.collaborator : null;
  const showexcursionselect = config.hasOwnProperty('product') ? false : true;

  const language = (config.hasOwnProperty('locale')) ? config.locale : 'es';
  const languageID=1;

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  //Recuperamos datos de la excursion cuando se seleccione
  useEffect(() => {
    if (excursionID != null){
      //Preparamos datos para envia por POST
      const postdata = new FormData();
      postdata.append('excursionID', excursionID);
      postdata.append('languageID', languageID);

      if (debug) console.log("debug", debug);
      if (debug) console.log("process.env.API_URL", process.env.API_URL);

      setIsLoading(true);
      //Recuperamos datos dese el servidor
      fetch(process.env.API_URL + "getExcursionInfo",{
        method: 'POST',
        body: postdata
      })
        .then((response) =>{
          if (response.ok) { //Verificamos que todo esté bien con la respuesta HTTP
            response.json().then((jsonresponse) => {
             if (debug) console.log("VTFORM -> getExcursionInfo", jsonresponse);
              if(jsonresponse.success){
                setExcursionsPrices(null);
                setExcursionInfo(jsonresponse.excursions);
              }else{
                handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef003] Ha ocurrido un error. Intentelo mas tarde' }]);
              }
            });
          } else {
            //Hubo un problema HTTP 4XX o 5XX
            handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef002] Ha ocurrido un error. Intentelo mas tarde' }]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          //Hubo un problema que no permitió hacer la solicitud
          handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef001] Ha ocurrido un error. Intentelo mas tarde' }]);
        });
    }
  }, [excursionID]);


  //Recuperamos datos de precio
  useEffect(() => {
    if (excursionID != null && excursionDate != null){

      const d = excursionDate.getDate() >= 10 ? excursionDate.getDate() : '0' + excursionDate.getDate();
      const m = (excursionDate.getMonth() + 1) >= 10 ? (excursionDate.getMonth()+1) : '0' + (excursionDate.getMonth()+1);
      const dateexcursion= d + '/' + m + '/' + excursionDate.getFullYear();

      //Preparamos datos para envia por POST
      const postdata = new FormData();
      postdata.append('excursionID', excursionID);
      postdata.append('dateexcursion', dateexcursion);

      setIsLoading(true);

      //Recuperamos datos dese el servidor
      fetch(process.env.API_URL + "getPricesAndAvailability",{
        method: 'POST',
        body: postdata
      })
        .then((response) =>{
          if (response.ok) { //Verificamos que todo esté bien con la respuesta HTTP
            response.json().then((jsonresponse) => {
              if (debug) console.log(jsonresponse);
              if(jsonresponse.success){
                if(jsonresponse.excursionsprices != null){

                  //Inicializamos el bookedPax
                  let initPax={};
                  for(const [id, price] of Object.entries(jsonresponse.excursionsprices)){
                    initPax[id]=0;
                  }
                  setBookedPax(initPax);

                  //Guardamos los precios
                  setExcursionsPrices(jsonresponse.excursionsprices);

                  //Guardamos plazas libres
                  setAvailability(jsonresponse.availability);

                  //Guardamos plazas libres
                  setPaxMax(jsonresponse.paxmax);

                  if (debug) console.log("availability", jsonresponse.availability);
                  if (debug) console.log("paxmax", jsonresponse.paxmax);

                }else handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef024] Ha ocurrido un error. Intentelo mas tarde' }]);
              }else handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef023] Ha ocurrido un error. Intentelo mas tarde' }]);
            });
          } else {
            //Hubo un problema HTTP 4XX o 5XX
            handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef022] Ha ocurrido un error. Intentelo mas tarde' }]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          //Hubo un problema que no permitió hacer la solicitud
          handleMessage([{sticky: true, severity: 'error', summary: 'Error', detail: '[ef021] Ha ocurrido un error. Intentelo mas tarde' }]);
        });
    }
  }, [excursionID, excursionDate]);

  //select language por defecto
  useEffect(() => {
    if (excursionInfo != null) setExcursionLanguage(excursionInfo.languages[0]);
  },[excursionInfo]);

  //Select Departure
  useEffect(() => {
    if (excursionInfo != null &&  excursionDate != null ){
      const weekday = excursionDate.getDay() === 0 ? 7 : excursionDate.getDay();

      //Buscamos cuantas salidas hay para el dia seleccionado
      const departureIDs = excursionInfo.departures.flatMap( departure => {
        //Salidas Semanales
        if (departure.type === 2) {
          if (departure.weekdays.indexOf(weekday) !== -1) return departure.id;
          else return [];
        }
      });

      //Información de la salida
      //Si solo hay una salida ese día la selecionamos. Si no abrimos ventana modal porque necesitamos accion manual
      if (departureIDs.length==1) setExcursionDeparture(departureIDs[0]);
      else  setExcursionDeparture(null);
    }
  }, [excursionInfo, excursionDate]);


  useEffect(() => {
    if (excursionDate == null || getFormPax() == 0) setShowAvailability(false);
  }, [excursionDate, bookedPax]);


  //--------------------------------------------------------------------------------------------------------------------
  function resetForm() {
    setExcursionID(null);
    setExcursionInfo(null);
    setExcursionDate(null);
    setExcursionLanguage(null);
    setExcursionDeparture(null);
    setExcursionsPrices(null);
    setSpecialExcursion(null);
    setHotelID(null);
    setAvailability(null);
    setBookedPax({});
  }

  //--------------------------------------------------------------------------------------------------------------------
  function getCartPax(){
    if (excursionDeparture !== null) return emdbCart.getProductNumItemsNoSupplement(excursionDeparture);
    else return 0;
  }

  //--------------------------------------------------------------------------------------------------------------------
  function getFormPax(){
    let totalPax=0;

    //Comprobamos primero que existen los objetos necesarios
    if (bookedPax !== null && excursionsPrices !== null){
      for (const idprice in bookedPax){
        if (!excursionsPrices[idprice]['supplement']) totalPax+=bookedPax[idprice];
      }
    }
    return totalPax;
  }

  //--------------------------------------------------------------------------------------------------------------------
  function getTotalPax() {
    //Separamos los totales porque necesitamos usar diferentes dependiendo del componente
    return getCartPax() + getFormPax();
  }

  //--------------------------------------------------------------------------------------------------------------------
  function handleMessage(error){

    if (msgs.current) {
      msgs.current.clear();
      msgs.current.show(error);
    }
  }

  function handleChangeExcursion(id) {
    setExcursionID(id);
    setExcursionDate(null);
  }

  function handleChangeExcursionDate(date) {
    setExcursionDate(date);
    setShowAvailability(false);
  }

  function handleAddtoCart() {
    if (debug) console.log("Añadiendo al carro");

    const dateexcursion = emdbUtils.getDateFormat(excursionDate);

    //Añadimos al carro
    Object.entries(bookedPax).forEach(([idprice, pax]) => {
      if (pax > 0){
        emdbCart.addProduct(
          excursionDeparture,
          excursionInfo.name,
          "",
          excursionInfo.id,
          dateexcursion,
          excursionID,
          excursionLanguage,
          specialExcursion,
          hotelID,
          idprice,
          excursionsPrices[idprice].name,
          excursionsPrices[idprice].supplement,
          pax,
          excursionsPrices[idprice].price,
          excursionsPrices[idprice].discount
        );
      }
    });

    setVisible(true);
    setShowAvailability(false);

  }

  const accept = () => {
    resetForm();
  }

  /*if (debug) console.log("############### DEBUG #################");
  if (debug) console.log("excursionInfo :");
  if (debug) console.log(excursionInfo);
  if (debug) console.log("showAvailability :" + showAvailability);*/

  if (!collaboratorID){
    console.log("[VTFORM]-> No se ha configurado el Id del colaborador")
  }else{
    return (
      <div className={styles.vtform}>

        <EmdbToast ref={msgs}/>

        <VTConfirmDialog visible={visible} onClose={() => setVisible(false)} onAccept={config.linktocart} t={t}/>

        <div className={styles.form}>
          <div className={styles.title}>
            {t("Seleccione fecha, número de participantes e idioma")}
            {isLoading && <LoadingIcon className={styles.loadingicon}/>}
          </div>
          <div className={styles.formelements}>
            {excursionInfo &&
              <div className={styles.formelement}>
                <VTCalendar selecteddate={excursionDate} disableDays={excursionInfo?.disabledays} onChange={handleChangeExcursionDate} />
              </div>
            }

            {excursionInfo &&
              <div className={styles.formelement}>
                <VTPrice
                  excursionsPrices={excursionsPrices}
                  bookedPax={bookedPax}
                  availability={availability}
                  excursionDeparture={excursionDeparture}
                  paxMax={paxMax}
                  getTotalPax={getTotalPax}
                  updatePaxs={setBookedPax}
                  showError={handleMessage}
                />
              </div>
            }

            {excursionInfo &&
              <div className={styles.formelement}>
                <VTSelectLanguage
                  languages={excursionInfo.languages}
                  selectedLanguage={excursionLanguage}
                  setLanguage={setExcursionLanguage}
                />
              </div>
            }

            <div className={styles.formelement}>
              <EmdbButtom className={styles.button} label={t("Ver disponibilidad")} onClick={()=>setShowAvailability(true)} disabled={(getFormPax() > 0 && excursionDate ) ? false: true} />
            </div>

          </div>
        </div>

        <VTSummary
          show={showAvailability}
          excursionInfo={excursionInfo}
          selectedDate={excursionDate}
          excursionsPrices={excursionsPrices}
          bookedPax={bookedPax}
          availability={availability}
          getTotalPax={getTotalPax}
          selectedDeparture={excursionDeparture}
          setDeparture={setExcursionDeparture}
          specialExcursion={specialExcursion}
          setSpecialExcursion={setSpecialExcursion}
          hotelID={hotelID}
          setHotelID={setHotelID}
          add2cart={handleAddtoCart}
          debug={debug}
        />

      </div>
    );
  }
}

export default VTForm;